import React from 'react'
import {Route, Routes} from 'react-router-dom'
import Main from './components/Main'
import Nav from './components/Nav'

export default function App() {
    return(
        <div>
            <Nav/>
            <Routes>
              <Route path="/" element={<Main/>}/>
            </Routes>
            {/* <Footer/> */}
        </div>
    )
}